//Added By jaseem 15-05-2026
import React from "react";
import { Col, Form } from "react-bootstrap";
import { REPORT_MONTH_OPTIONS } from "../utils/reportFormUtil";

//Added By jaseem 15-05-2026
export default function ReportMonthsField({ value, onChange, className = "" }) {
  return (
    <Col lg={6}>
      <Form.Group className={className} controlId="formBasicMonths">
        <Form.Label className="form-view-label">Month</Form.Label>
        <Form.Select name="months" value={value || ""} onChange={onChange}>
          <option value="">--Select Month--</option>
          {REPORT_MONTH_OPTIONS.map((label) => (
            <option key={label} value={label}>
              {label}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </Col>
  );
}
